<template>
  <div>
    <Navbar />
    <div class="step-page">
      <div class="title">
        <span style="font-size: 1.8rem; font-weight: bold"
          >IDL 間接人員人事資料表</span
        ><br />
        <span class="en-text">IDL staff HR information form</span>
      </div>

      <div class="title">
        <span style="font-weight: bold"
          >應徵工程職務、管理職務與其他後勤職務<br
        /></span>
        <span class="en-text"
          >Apply for engineering jobs, managerial duties and other logistic
          jobs</span
        >
      </div>

      <el-tabs
        v-model="activeName"
        :tab-position="windowWidth > 1024 ? 'left' : 'top'"
        class="tab-component"
      >
        <el-tab-pane label="面談背景資料" name="面談背景資料">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLWorkedInfoComplete }"
          >
            <span class="tab-name">
              面談背景資料<br />
              Interview background
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <WorkedInfo
              v-if="activeName === '面談背景資料'"
              :source="'resume'"
              :key="workedInfoKey"
              :nextTab="'個人資料'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="個人資料" name="個人資料">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLBaseInfoComplete }"
          >
            <span class="tab-name">
              個人資料<br />
              Personal information
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填。<br />
              <span class="en-text"
                >The applicant must fill out the following fields based on job
                requirements, if do not want to disclose personal information,
                can select not to fill out.</span
              >
            </div>
            <BaseInfo
              v-if="activeName === '個人資料'"
              :source="'resume'"
              :key="baseInfoKey"
              :nextTab="'學歷'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="學歷" name="學歷">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLEducationComplete }"
          >
            <span class="tab-name">
              學歷<br />
              Education
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              請至少提供一項已經修業完成的學歷，並從最高學歷開始填寫，且至少提供一項已經修業完成的學歷，而若資料庫中無您的母校，請直接填寫校名。<br />
              <span class="en-text"
                >Please provide at least one degree that has been
                completed.</span
              >
            </div>
            <Education
              v-if="activeName === '學歷'"
              :source="'resume'"
              :key="educationKey"
              :nextTab="'工作經歷'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="工作經歷" name="工作經歷">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLWorkExperienceComplete }"
          >
            <span class="tab-name">
              工作經歷<br />
              Work Experience
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              請從最近一份工作經歷開始填起，「薪資」請填寫阿拉伯數字，例如：「29,000」。<br />
              <span class="en-text"
                >Please start from the most recent work experience. Please fill
                in Arabic numerals for "Salary", for example: "29,000 ".</span
              >
            </div>
            <WorkExperience
              v-if="activeName === '工作經歷'"
              :source="'resume'"
              :key="workExperienceKey"
              :nextTab="'專業技能'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="專業技能" name="專業技能">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLSkillComplete }"
          >
            <span class="tab-name">
              專業技能<br />
              Professional Skills
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <Skill
              v-if="activeName === '專業技能'"
              :source="'resume'"
              :key="skillKey"
              :nextTab="'活動經驗'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="活動經驗" name="活動經驗">
          <span
            slot="label"
            class="resume-tab"
            :class="{
              finish: resumeCompleteness.IsIDLActivityExperienceComplete,
            }"
          >
            <span class="tab-name">
              活動經驗<br />
              Activity Experience
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <Activity
              v-if="activeName === '活動經驗'"
              :source="'resume'"
              :key="activityKey"
              :nextTab="'語言能力'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="語言能力" name="語言能力">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLLanguageComplete }"
          >
            <span class="tab-name">
              語言能力<br />
              Language Ability
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 請用優、良、可、劣四個等級來評比自己聽、說、讀、寫的能力。<br />
              <span class="en-text">
                Please use Excellent, Good, Fair, Inferior four grades to
                compare your listening, speaking, reading and writing ability.
              </span>
            </div>
            <Language
              v-if="activeName === '語言能力'"
              :source="'resume'"
              :key="languageKey"
              :nextTab="'工作配合'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="工作配合" name="工作配合">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLWorkCooperationComplete }"
          >
            <span class="tab-name">
              工作配合<br />
              Work Cooperation
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <WorkCooperation
              v-if="activeName === '工作配合'"
              :source="'resume'"
              :key="workCooperationKey"
              :nextTab="'面試情況'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="面試情況" name="面試情況">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLInterviewInfoComplete }"
          >
            <span class="tab-name">
              面試情況<br />
              Interview condition
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              ** 請列出您最近參加面試的工作職缺情況。<br />
              <span class="en-text"
                >Please list your most recent job opening application interview
                circumstances.</span
              >
            </div>
            <InterviewStatus
              v-if="activeName === '面試情況'"
              :source="'resume'"
              :key="interviewStatusKey"
              :nextTab="'職缺需求'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="職缺需求" name="職缺需求">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLWorkConsideration }"
          >
            <span class="tab-name">
              職缺需求<br />
              Job vacancies
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              **
              請選擇您應徵此工作職缺的需求：《請依重要性，於每個項目下方排序第1~第10順位，並說明重視原因》<br />
              <span class="en-text">
                Please select the job occupations you need to apply for: "Please
                rank each item from first to tenth according to the importance,
                and explain its importance"
              </span>
            </div>
            <WorkConsideration
              v-if="activeName === '職缺需求'"
              :source="'resume'"
              :key="workConsiderationKey"
              :nextTab="'保密義務'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="保密義務" name="保密義務">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLNDAComplete }"
          >
            <span class="tab-name">
              保密義務<br />
              Confidential duty
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。<br />
              **
              提醒您，以下說明內容應真確詳實，並與您所簽訂的保密義務條款相同。<br />
              <span class="en-text">
                Remark: "Confidentiality Obligation" means that you are obliged
                to keep confidential the confidential information of your former
                employer, and you must not continue to use, disclose or hold it
                after you leave your job.
              </span>
            </div>
            <Confidentiality
              v-if="activeName === '保密義務'"
              :source="'resume'"
              :key="confidentialityKey"
              :nextTab="'競業禁止限制'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="競業禁止限制" name="競業禁止限制">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLNCCComplete }"
          >
            <span class="tab-name">
              競業禁止限制<br />
              Non competition restriction
            </span>
          </span>
          <div class="step-content no-bg">
            <div class="step-tip mb-2">
              註：「競業禁止」是指您曾與前雇主約定，在離職後的一定期間內，不能受雇於與該前雇主之營業性質相同或類似的工作。<br />
              **
              提醒您，以下說明內容應真確詳實，並與您所簽訂的競業禁止條款相同。<br />
              <span class="en-text">
                Remark: "Non-competition" means that you have agreed with your
                former employer that within a certain period of time after
                leaving the job, you cannot be employed in a job with the same
                or similar business nature as that of the former employer.
              </span>
            </div>
            <NonCompete
              v-if="activeName === '競業禁止限制'"
              :source="'resume'"
              :key="nonCompeteKey"
              :nextTab="'智財'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="智財" name="智財">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLIPComplete }"
          >
            <span class="tab-name">
              智財<br />
              Intellectual properties exist
            </span>
          </span>
          <div class="step-content no-bg mt-1">
            <IntellectualProperty
              v-if="activeName === '智財'"
              :source="'resume'"
              :key="intellectualPropertyKey"
              :nextTab="'自傳'"
              @changeTab="changeTab"
            />
          </div>
        </el-tab-pane>

        <el-tab-pane label="自傳" name="自傳">
          <span
            slot="label"
            class="resume-tab"
            :class="{ finish: resumeCompleteness.IsIDLAutobiographyComplete }"
          >
            <span class="tab-name">
              自傳<br />
              Autobiography
            </span>
          </span>
          <div class="step-content no-bg">
            <Autobiography
              v-if="activeName === '自傳'"
              :source="'resume'"
              :key="autobiographyKey"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Navbar from "@/components/candidate/NavBar";
import WorkedInfo from "@/components/customize/Front/IDL/WorkedInfo";
import BaseInfo from "@/components/customize/Front/IDL/BaseInfo";
import Education from "@/components/customize/Front/IDL/Education";
import WorkExperience from "@/components/customize/Front/IDL/WorkExperience";
import Skill from "@/components/customize/Front/IDL/Skill";
import Activity from "@/components/customize/Front/IDL/Activity";
import Language from "@/components/customize/Front/IDL/Language";
import Autobiography from "@/components/customize/Front/IDL/Autobiography";
import WorkCooperation from "@/components/customize/Front/IDL/WorkCooperation";
import InterviewStatus from "@/components/customize/Front/IDL/InterviewStatus";
import WorkConsideration from "@/components/customize/Front/IDL/WorkConsideration";
import Confidentiality from "@/components/customize/Front/IDL/Confidentiality";
import NonCompete from "@/components/customize/Front/IDL/NonCompete";
import IntellectualProperty from "@/components/customize/Front/IDL/IntellectualProperty";

export default {
  name: "AseIDLResume",

  components: {
    Navbar,
    WorkedInfo,
    BaseInfo,
    Education,
    WorkExperience,
    Skill,
    Activity,
    Language,
    Autobiography,
    WorkCooperation,
    InterviewStatus,
    WorkConsideration,
    Confidentiality,
    NonCompete,
    IntellectualProperty,
  },
  data() {
    return {
      activeName: "面談背景資料",

      workedInfoKey: 0,
      baseInfoKey: 0,
      educationKey: 0,
      workExperienceKey: 0,
      skillKey: 0,
      activityKey: 0,
      languageKey: 0,
      autobiographyKey: 0,
      workCooperationKey: 0,
      interviewStatusKey: 0,
      workConsiderationKey: 0,
      confidentialityKey: 0,
      nonCompeteKey: 0,
      intellectualPropertyKey: 0,
      windowWidth: 0,

      timer: 0,
    };
  },

  watch: {
    activeName: function (newVal) {
      switch (newVal) {
        case "面談背景資料":
          this.workedInfoKey += 1;
          break;
        case "個人資料":
          this.baseInfoKey += 1;
          break;
        case "學歷":
          this.educationKey += 1;
          break;
        case "工作經歷":
          this.workExperienceKey += 1;
          break;
        case "專業技能":
          this.skillKey += 1;
          break;
        case "活動經驗":
          this.activityKey += 1;
          break;
        case "語言能力":
          this.languageKey += 1;
          break;
        case "工作配合":
          this.workCooperationKey += 1;
          break;
        case "面視情況":
          this.interviewStatusKey += 1;
          break;
        case "職缺需求":
          this.workConsiderationKey += 1;
          break;
        case "保密義務":
          this.confidentialityKey += 1;
          break;
        case "禁止條款":
          this.nonCompeteKey += 1;
          break;
        case "智財":
          this.intellectualPropertyKey += 1;
          break;
        case "自傳":
          this.autobiographyKey += 1;
          break;
        default:
          this.workedInfoKey += 1;
      }
    },
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    changeTab(name) {
      this.timer = setTimeout(() => {
        this.activeName = name;
      }, 1500);
    },
  },

  computed: {
    ...mapGetters(["resumeCompleteness"]),
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.step-tip {
  color: #fff;
  font-size: 0.85em;
}

.tab-name {
  display: inline-block;
  line-height: 20px;
}

/deep/ .el-tabs__content {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-button {
    background: transparent;

    border-radius: 4px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;

    background-color: rgba(0, 0, 0, 0.4);

    border: 1px solid slategrey;
  }

  &::-webkit-scrollbar-track {
    box-shadow: transparent;
  }

  @media screen and (min-width: 768px) {
    height: calc(100vh - 175px);
    overflow: auto;
  }
}

/deep/ .tab-component {
  .el-tabs__item {
    color: #fff;
    height: 55px;

    &.is-active {
      color: #22c59a;
    }
  }

  .el-tabs__active-bar {
    background-color: #22c59a;
  }

  .important-table {
    width: 100%;
    margin: 0 auto;
    th {
      color: #fff;
      padding: 10px;
      text-align: center;
    }
    td {
      padding: 10px;
      input,
      select {
        border: none;
        border-radius: 25px;
        width: 100%;
        line-height: 30px;
        height: 30px;
        padding: 0 10px;
      }
    }
  }
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}

/deep/ .el-icon-arrow-left:before {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}
/deep/ .el-icon-arrow-right:before {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}

.title {
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
}

.en-text {
  opacity: 0.6;
  font-size: 0.9em;
}
</style>
